import useDropdownMenu from 'react-accessible-dropdown-menu-hook'
import LoginButton from 'src/components/LoginButton/LoginButton'
import ModalLogin from 'src/components/LoginModal/LoginModal'
import usePersistedState from 'src/hooks/usePersistedState'
import { Box } from '@material-ui/core'
import { useStyles } from './LoginDropdown.styles'

const LoginDropdown = () => {
  const { buttonProps, isOpen, setIsOpen } = useDropdownMenu(1)
  const [loggedIn, setLoggedIn] = usePersistedState('auth-token', '')
  const classes = useStyles()

  return (
    <>
      <Box className={classes.dropdownContainer}>
        <LoginButton isLoggedIn={loggedIn} {...buttonProps} />
        <Box
          className={`${classes.dropdown} ${
            isOpen ? classes.dropdownVisible : ''
          }`}
          role="menu"
        >
          <ModalLogin
            openModal={setIsOpen}
            loggedIn={loggedIn}
            setLoggedIn={setLoggedIn}
          />
        </Box>
      </Box>
    </>
  )
}

export default LoginDropdown
